import script from "./NoticiaView.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticiaView.vue?vue&type=script&setup=true&lang=js"

import "./NoticiaView.vue?vue&type=style&index=0&id=6c2109f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c2109f2"]])

export default __exports__